import { render, staticRenderFns } from "./CollectionCost.vue?vue&type=template&id=08efc547&"
import script from "./CollectionCost.vue?vue&type=script&lang=js&"
export * from "./CollectionCost.vue?vue&type=script&lang=js&"
import style0 from "./CollectionCost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports